<template lang="html">
  <v-dialog v-model="dialog" width="800" @click:outside="clearData">
    <template v-slot:activator="{ on }">
      <v-btn class="btn-large-space btn-danger mr-4" color="error" v-on="on">
        {{ $t("requestDelete") }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t("selectReason") }}
      </v-card-title>

      <v-card-text>
        <v-container fluid>
          <v-stepper v-model="e1">
            <v-stepper-header>
              <v-stepper-step :complete="e1 > 1" step="1">{{
                $t("reason")
              }}</v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="e1 > 2" step="2">{{
                $t("detail")
              }}</v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="3">{{ $t("summary") }}</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1"
                ><v-radio-group v-model="radios" :mandatory="false">
                  <v-radio
                    v-for="reason in reasons"
                    :key="reason.value"
                    :label="$t(reason.label)"
                    :value="reason"
                  ></v-radio>
                </v-radio-group>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-textarea
                  v-model="description"
                  v-if="radios.value === 'other'"
                  auto-grow
                  outlined
                  :placeholder="$t('insert.reason')"
                  rows="5"
                >
                </v-textarea>
                <v-textarea
                  v-model="description"
                  v-else-if="radios.value === 'error'"
                  auto-grow
                  outlined
                  :placeholder="$t('insert.description')"
                  rows="5"
                >
                </v-textarea>
                <v-data-table
                  v-else-if="radios.value === 'duplicate'"
                  :items="items"
                  :headers="headers"
                  class="elevation-1"
                  :items-per-page="5"
                  :search="search"
                  @click:row="selectItem"
                >
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title>{{
                        $t("selectDuplicate")
                      }}</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        :label="$t('search')"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </template>
                </v-data-table>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-row
                  ><v-col cols="12" class="text-left"
                    ><h4>
                      <span class="bold">{{ $t("reason") }}:</span>
                      {{ $t(radios.label) }}
                    </h4></v-col
                  ></v-row
                >
                <v-row align="center"
                  ><v-col cols="12"
                    ><v-textarea
                      outlined
                      :label="$t('form.description')"
                      v-model="description"
                      readonly
                    ></v-textarea> </v-col
                ></v-row>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false">
          {{ $t("button.close") }}
        </v-btn>
        <v-btn v-if="e1 > 1" @click="e1 = e1 - 1">{{
          $t("button.back")
        }}</v-btn>
        <v-btn
          v-if="e1 < 3"
          :disabled="radios === ''"
          color="primary"
          @click="e1 = e1 + 1"
        >
          {{ $t("button.continue") }}
        </v-btn>
        <v-btn v-if="e1 === 3" color="primary" @click="sendDeleteRequest">
          {{ $t("button.send") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    urlObjects: {
      type: String,
      required: true
    },
    object_type: {
      type: String,
      required: true
    },
    headers: Array
  },
  data() {
    return {
      search: "",
      dialog: false,
      radios: "",
      description: "",
      selectedItem: "",
      e1: 1,
      items: [],
      reasons: [
        { label: "forms.deleteRequest.options.duplicate", value: "duplicate" },
        { label: "forms.deleteRequest.options.errorData", value: "error" },
        { label: "forms.deleteRequest.options.others", value: "other" }
      ]
    };
  },

  methods: {
    getItems() {
      const path = this.$store.state.endpoint + "/" + this.urlObjects;
      axios
        .get(path)
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    clearData() {
      this.e1 = 1;
      this.radios = "";
      this.selectedItem = "";
      this.description = "";
    },

    selectItem(item) {
      this.selectedItem = item;
      this.e1 = 3;
      this.description = this.$t("forms.deleteRequest.reason");
      if (this.object_type === "investigator") {
        this.description += this.selectedItem.preferred_name.given_name;
      } else if (this.object_type === "publication") {
        this.description += this.selectedItem.title;
      } else if (this.object_type === "project") {
        this.description += this.selectedItem.title["gl"];
      }
    },
    sendItem(form) {
      let path =
        this.$store.state.endpoint +
        "/user/moderatedOperations/send/" +
        this.object_type +
        "/" +
        form.id;
      axios
        .patch(path)
        .then(response => {
          form.state = response.data.state;
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("forms.deleteRequestSent")
          });
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("alert", {
            color: "error",
            text: "An error occurred while sending the delete request."
          });
        });
    },

    sendDeleteRequest() {
      let data = {
        object_type: this.object_type,
        reason: this.radios.value,
        description: this.description,
        object_id: this.item.id,
        form_name: "deleteRequest",
        data: {
          user: {
            reason: this.radios.label,
            description: this.description
          }
        }
      };
      let title;
      switch (this.object_type) {
        case "investigator":
          title =
            this.item.preferred_name.given_name +
            " " +
            this.item.preferred_name.family_name;
          break;
        case "publication":
          title = this.item.title;
          break;
        case "project":
          if (this.item.title["gl"] !== undefined) {
            title = this.item.title["gl"];
          } else if (this.item.title["es"] !== undefined) {
            title = this.item.title["es"];
          } else {
            title = this.item.title["en"];
          }
          break;
        default:
          title = "No title";
      }
      data["title"] = title;
      data["data"]["user"]["name"] = title;
      let path = this.$store.state.endpoint + "/moderatedOperations";
      axios
        .post(path, data)
        .then(response => {
          this.sendItem(response.data);
        })
        .catch(error => {
          console.log(error);
          console.log(error.response.data);
          this.$store.commit("alert", {
            color: "error",
            text: "An error occurred while creating the delete request"
          });
        });
      this.dialog = false;
    }
  },

  created() {
    this.getItems();
  }
};
</script>
